onDomReady(() => {
   $$('.filterSelectField').addEvent('change', function (ev) {
      window.location = this.getSelected()[0].get('value');
   });
});
